import { FormEvent, useState } from 'react'
import Section from '../../Common/Section/Section'
import './ContactSection.css'
import InputErrorWrapper from '../../Common/FormInput/InputErrorWrapper'
import { ErrorShowInfo } from '../../../models/ErrorShowInfo'
import { ContactRequest } from '../../../models/ContactRequest'
import { ContactResponse } from '../../../models/ContactResponse'
import HttpClient from '../../../util/HttpClient'
import ContactMessageBanner from './ContactMessageBanner/ContactMessageBanner'

function ContactSection() {

    const httpClient: HttpClient = new HttpClient()

    const sendEmail = async (e: FormEvent) => {
        e.preventDefault() 
        clearErrors()
        if(checkContactFields()) {
            setLoading(true)
            console.log("Sending email")
            
            let response: ContactResponse = await httpClient.postContactMessage({name: name, email: email, message: message} as ContactRequest)
            if(response.success){
                clearContactFields()
                setError(false)
                setShowMessageBanner(true)
            }else{
                setError(true)
                setShowMessageBanner(true)
            }
        }
        setLoading(false)
    }

    const clearContactFields = () => {
        setName("")
        setEmail("")
        setMessage("")
    }

    const checkContactFields = (): boolean => {
        let errorFree = true
        
        // validate name field
        if(name) {
            setNameError({showErrorMessage: false, showErrorOutline: false})
        }else{
            setNameError({showErrorMessage: true, showErrorOutline: true})
            errorFree = false
        }

        // validate email field
        if(isValidEmail(email)) {
            setEmailError({showErrorMessage: false, showErrorOutline: false})
        }else{
            setEmailError({showErrorMessage: true, showErrorOutline: true})
            errorFree = false
        }
        
        // validate message field
        if(message) {
            setMessageError({showErrorMessage: false, showErrorOutline: false})
        }else{
            setMessageError({showErrorMessage: true, showErrorOutline: true})
            errorFree = false
        }

        return errorFree
    }

    const clearErrors = () => {
        setNameError({showErrorMessage: false, showErrorOutline: false})
        setEmailError({showErrorMessage: false, showErrorOutline: false})
        setMessageError({showErrorMessage: false, showErrorOutline: false})
    }

    const isValidEmail = (email: string): boolean => {
        const emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/;
        return emailRegex.test(email);
    }

    const [name, setName] = useState("")
    const [email, setEmail] = useState("")
    const [message, setMessage] = useState("")
    const [error, setError] = useState(false)
    const [showMessageBanner, setShowMessageBanner] = useState(false)
    
    const [nameError, setNameError] = useState<ErrorShowInfo>({showErrorMessage: false, showErrorOutline: false})
    const [emailError, setEmailError] = useState<ErrorShowInfo>({showErrorMessage: false, showErrorOutline: false})
    const [messageError, setMessageError] = useState<ErrorShowInfo>({showErrorMessage: false, showErrorOutline: false})

    const [loading, setLoading] = useState(false)


    return (
        <Section id={"contact-section"} 
            sectionTitle="Contact me" 
            titleColor='#ffffff'
            sectionSubtitle="I would love to hear from you!"
            subtitleColor='#ffffff'
            >
            <div className='contact-container'>
                <form onSubmit={sendEmail} className='contact-form'>
                    {showMessageBanner && 
                        <ContactMessageBanner error={error} close={setShowMessageBanner} name={name} message={message} email={email}/>
                    }
                    <InputErrorWrapper id="name-field" className="contact-form-input" showErrorMessage={nameError.showErrorMessage} errorMessage='Name is required.'>
                        <input placeholder='Your name...' className={nameError.showErrorOutline ? "input-error" : ""} value={name} onChange={(event) => { 
                                setName(event.target.value) 
                                setNameError({showErrorMessage: nameError.showErrorMessage, showErrorOutline: false})
                            }} />
                    </InputErrorWrapper>
                    <InputErrorWrapper id="email-field" className="contact-form-input" showErrorMessage={emailError.showErrorMessage} errorMessage='Enter a valid email address.'>
                        <input placeholder='Your email...' className={emailError.showErrorOutline ? "input-error" : ""} value={email} onChange={(event) => { 
                                setEmail(event.target.value) 
                                setEmailError({showErrorMessage: emailError.showErrorMessage, showErrorOutline: false})
                            }} />
                    </InputErrorWrapper>
                    <InputErrorWrapper id="message-field" className="contact-form-input" showErrorMessage={messageError.showErrorMessage} errorMessage='Message is required.'>
                        <textarea rows={6} placeholder='Your message...' className={messageError.showErrorOutline ? "input-error" : ""} value={message} onChange={(event) => { 
                                setMessage(event.target.value) 
                                setMessageError({showErrorMessage: messageError.showErrorMessage, showErrorOutline: false})
                            }} />
                    </InputErrorWrapper>
                    <button type='submit' className='button'>{loading ? "Sending message..." : "Send Message"}</button>
                </form>
            </div>
        </Section>
    )
}

export default ContactSection